import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { makeEntityChildrenIdsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type ListsContainerProps } from "./component";
import { makeClassNameSelector, makeContainerStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const classNameSelector = makeClassNameSelector();
  const containerStyleSelector = makeContainerStyleSelector();
  const itemsIdsSelector = makeEntityChildrenIdsSelector();

  return (state: AppState, props: RootContainerProps): ListsContainerProps => {
    return {
      ...props,
      className: classNameSelector(state, props),
      containerStyle: containerStyleSelector(state, props),
      itemsIds: itemsIdsSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
